require '../../../common/frontend/views/alert_message_view'

class Extranet.Views.RequestResponseView extends Backbone.View

  el: 'body'  # Use body for event delegation since modals are dynamically created

  events: {}

  initialize: (options) ->
    @alertMessage = new Extranet.Views.AlertMessage {selector: '.alert-message'}
    @requestResponseData = null

  render: (bookingId, hotelUuid, checkInDate, checkOutDate, channelManager, inventoryUnitId) ->
    @bookingId = bookingId
    @hotelUuid = hotelUuid
    @checkInDate = checkInDate
    @checkOutDate = checkOutDate
    @channelManager = channelManager
    @inventoryUnitId = inventoryUnitId
    @_fetchRequestResponse()

  _fetchRequestResponse: ->
    @_showLoading()
    @fetchRequestResponse(@bookingId, @hotelUuid, @channelManager, @inventoryUnitId)

  _buildRequestUrl: (hotelUuid) ->
    # Use existing reservations API
    return "/v2/getaways/extranet/hotels/#{hotelUuid}/reservations"

  fetchRequestResponse: (bookingId, hotelUuid, channelManager, inventoryUnitId) ->
    # Convert MM/DD/YYYY to YYYY-MM-DD format
    checkInDate = @_convertDateFormat(@checkInDate)
    checkOutDate = @_convertDateFormat(@checkOutDate)
    
    csrfToken = $('#csrf_token').val()
    
    # Fallback if csrf_token not found
    if not csrfToken
      csrfToken = $('input[name="_csrf"]').val()
    
    if not csrfToken
      @_handleError(null, 'error', 'No CSRF token found')
      return

    requestData = {
      booking_code: bookingId
      includeRequestResponse: true
      limit: 25
      offset: 0
      check_in_begin: checkInDate
      check_in_end: checkOutDate
      _csrf: csrfToken
    }

    # Add channel manager if available
    if channelManager
      requestData.channelManager = channelManager
    
    # Add inventory unit ID if available
    if inventoryUnitId
      requestData.inventoryUnitId = inventoryUnitId

    ajaxOptions = {
      type: 'POST'
      url: @_buildRequestUrl(hotelUuid)
      data: requestData
      dataType: 'json'
      global: false
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
      headers: {
        'Accept': 'application/json'
        'X-Request-ID': @_generateRequestId()
      }
    }

    return $.ajax(ajaxOptions)
      .done((response) =>
        @_handleSuccess(response)
      )
      .fail((jqXHR, textStatus, errorThrown) =>
        @_handleError(jqXHR, textStatus, errorThrown)
      )

  _handleError: (jqXHR, textStatus, errorThrown) ->
    requestId = jqXHR?.getResponseHeader('x-request-id')
    errorMessage = "Request failed. Request ID: #{@_escapeHtml(requestId)}"

    try
      responseData = JSON.parse(jqXHR?.responseText || '{}')
      if responseData?.message
        errorMessage = responseData.message
    catch e
      # Silent error handling

    # Show error using the new error handler
    @_showError(errorMessage)
    @_hideLoading()

  _convertDateFormat: (dateString) ->
    # Convert MM/DD/YYYY to YYYY-MM-DD
    if dateString and dateString.includes('/')
      parts = dateString.split('/')
      if parts.length is 3
        month = parts[0].padStart(2, '0')
        day = parts[1].padStart(2, '0')
        year = parts[2]
        return "#{year}-#{month}-#{day}"
    return dateString

  _generateRequestId: ->
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace /[xy]/g, (c) ->
      r = Math.random() * 16 | 0
      v = if c == 'x' then r else (r & 0x3 | 0x8)
      v.toString(16)

  _findModal: ->
    # Try multiple selectors to find the modal
    modal = $('.modal:visible')
    if modal.length == 0
      modal = $('.booking-modal:visible')
    if modal.length == 0
      modal = $('.modal.booking-modal')
    if modal.length == 0
      modal = $('[id^="booking-modal-"]')
    return modal

  _updateModalContent: (booking) ->
    # Find the specific modal for this booking
    modal = @_findModal()
    if modal.length > 0
      # Get the request/response data
      requestResponseData = booking.get('requestResponseData')
      
      # Find the request-response content area in the modal
      requestResponseContent = modal.find('.request-response-content')
      
      if requestResponseData
        # Show the content area
        requestResponseContent.show()
        
        if requestResponseData.error
          # Show error message
          requestResponseContent.html("
            <div class='alert alert-danger' style='margin: 20px 0;'>
              <h5><i class='icon-warning'></i> Error</h5>
              <p>#{requestResponseData.error}</p>
            </div>
          ")
        else if requestResponseData.requests?.length > 0
          # Show success data
          requestsHtml = @_formatRequestsHtml(requestResponseData)
          responsesHtml = @_formatResponsesHtml(requestResponseData)
          requestResponseContent.html("
            <div class='row'>
              <div class='col-md-6'>
                <h5><i class='icon-arrow-up'></i> Requests (#{requestResponseData.requests.length})</h5>
                <div class='request-section'>
                  <div class='request-method' style='font-weight: bold; color: #007bff; margin-bottom: 5px;'>Reservation ID: #{requestResponseData.reservationId}</div>
                  #{requestsHtml}
                </div>
              </div>
              <div class='col-md-6'>
                <h5><i class='icon-arrow-down'></i> Responses (#{requestResponseData.responses.length})</h5>
                <div class='response-section'>
                  #{responsesHtml}
                </div>
              </div>
            </div>
          ")
        else
          # Show no data message
          requestResponseContent.html("
            <div class='text-center' style='padding: 20px; color: #666;'>
              <p>No request/response data available for this booking</p>
            </div>
          ")
      else
        # Hide the content area
        requestResponseContent.hide()
      
    else

  _handleSuccess: (response) ->
    
    try
      # Extract request/response data from the API response
      requestResponseData = null
      if response?.requestResponse?
        # Request/response data is at the root level
        requestResponseData = response.requestResponse
      else if response?.reservations?.length > 0
        # Fallback: look for request/response data in reservations
        for reservation in response.reservations
          if reservation.requestResponse?
            requestResponseData = reservation.requestResponse
            break
      
      if requestResponseData
        
        # Store the data for template access
        @requestResponseData = requestResponseData
        
        # Update the booking model and re-render the table
        @_updateBookingModelAndRerender(requestResponseData)
        
      else
        # Show error message
        @_showError('No request/response data available for this booking')
    catch error
      console.error('Error in _handleSuccess:', error)
      @_showError('Error processing request/response data: ' + error.message)
    finally
      @_hideLoading()

  _showError: (message) ->
    # Find the modal and show error message
    modal = @_findModal()
    if modal.length > 0
      requestResponseContent = modal.find('.request-response-content')
      if requestResponseContent.length > 0
        escapedMessage = @_escapeHtml(message)
        requestResponseContent.show().html("
          <div class='alert alert-danger' style='margin: 20px 0;'>
            <h5><i class='icon-warning'></i> Error</h5>
            <p>#{escapedMessage}</p>
          </div>
        ")
      else
    else

  _updateBookingModelAndRerender: (requestResponseData) ->
    # Find the booking model and update it
    if @bookingId
      bookingsPageView = $('section#page').data('view')
      if bookingsPageView?.bookingsCollection
        # Find the booking model
        booking = null
        targetBookingId = @bookingId
        bookingsPageView.bookingsCollection.each (model) ->
          if model.get('bookingId')?.toString() is targetBookingId?.toString()
            booking = model
            return false  # Break the loop
        
        if booking
          # Update the booking model with request/response data
          booking.set('requestResponseData', requestResponseData)
          
          # Update only the specific modal instead of re-rendering entire table
          @_updateSpecificModal(booking)
        else
      else
    else

  _updateSpecificModal: (booking) ->
    # Get the booking data for template rendering
    bookingData = booking.toJSON()
    
    # Use the presenter to format the data properly
    bookingsPageView = $('section#page').data('view')
    if bookingsPageView?.presenter
      # Create a temporary collection with just this booking
      tempCollection = new Extranet.Collections.Bookings([booking])
      tempPresenter = new Extranet.Presenters.Bookings({collection: tempCollection})
      hotelData = Extranet.ClientConfig?.hotelData
      formattedBookingData = tempPresenter.toHash(hotelData)[0]
    else
      formattedBookingData = bookingData
    
    # Find the specific modal for this booking
    modalId = "booking-modal-#{bookingData.bookingId}"
    modal = $("##{modalId}")
    
    if modal.length > 0
      
      # Re-render only this modal using the template
      modalContent = TemplateHelper.render('booking_information_popup', formattedBookingData)
      
      # Replace the modal content
      modal.replaceWith(modalContent)
      
      # Re-show the modal if it was visible
      newModal = $("##{modalId}")
      if newModal.length > 0
        newModal.modal('show')
    else

  _showLoading: ->
    modal = @_findModal()
    modal.find('.loading-indicator').show()
    modal.find('.request-response-content').hide()
    modal.find('.error-message').hide()
    modal.find('.show-request-response-btn').prop('disabled', true).text('Loading...')

  _hideLoading: ->
    modal = @_findModal()
    modal.find('.loading-indicator').hide()
    modal.find('.show-request-response-btn').prop('disabled', false).text('Show Request/Response')

  _clearRequestResponseData: ->
    @requestResponseData = null

  _escapeHtml: (text) ->
    return '' unless text?
    text.toString()
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;')
      .replace(/\//g, '&#x2F;')

  _clearModalContent: ->
    # Find all visible modals and clear their request/response content
    $('.modal:visible').each ->
      modal = $(this)
      requestResponseContent = modal.find('.request-response-content')
      if requestResponseContent.length > 0
        # Hide the content and reset to default state
        requestResponseContent.hide().html('
          <div class="text-center" style="padding: 20px; color: #666;">
            <p>Click "Show Request/Response" to load the data</p>
          </div>
        ')
    

  getRequestResponseData: ->
    return @requestResponseData